import React, { useMemo } from "react";
import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];
const WHILE_IN_VIEW = { opacity: 1, y: 0 };

/** Luxury entrance — slow, vertical, easing out. Like heat and breath. */
export const Reveal = ({ children, delay = 0, y = 26, className = "", once = true }) => {
  const reduce = useReducedMotion();
  const initial = useMemo(() => (reduce ? { opacity: 1 } : { opacity: 0, y }), [reduce, y]);
  const viewport = useMemo(() => ({ once, amount: 0.25 }), [once]);
  const transition = useMemo(() => ({ duration: 0.9, delay, ease: EASE }), [delay]);
  return (
    <motion.div
      className={className}
      initial={initial}
      whileInView={WHILE_IN_VIEW}
      viewport={viewport}
      transition={transition}
    >
      {children}
    </motion.div>
  );
};
